// extracted by mini-css-extract-plugin
export default {"containerStars":"Star_containerStars__r0fD9","star":"Star_star__+QZt2","input":"Star_input__kp8bf"};